import * as React from 'react';
import { useTimestampStyles_unstable } from './useTimestampStyles';
import { useText_unstable, renderText_unstable } from '@fluentui/react-components';
// Timestamp component - TODO: add more docs
export const Timestamp = /*#__PURE__*/React.forwardRef((props, ref) => {
  const state = useText_unstable({
    as: 'h4',
    ...props
  }, ref);
  useTimestampStyles_unstable(state);
  return renderText_unstable(state);
});
Timestamp.displayName = 'Timestamp';
//# sourceMappingURL=Timestamp.js.map